export default __webpack_public_path__ + "static/media/rasam_powder.7ff46402.jpg";